export var XHREventType;
(function (XHREventType) {
    XHREventType["LOAD"] = "faro.xhr.load";
    XHREventType["ABORT"] = "faro.xhr.abort";
    XHREventType["ERROR"] = "faro.xhr.error";
    XHREventType["TIMEOUT"] = "faro.xhr.timeout";
})(XHREventType || (XHREventType = {}));
export const serverTimingHeader = 'server-timing';
export const faroRumHeader = 'x-faro-session';
export const makeFaroRumHeaderValue = (sessionId) => {
    return `session_id=${sessionId}`;
};
//# sourceMappingURL=types.js.map